// Read-only display of a prospect's peer-group answers (3 open-ended + 7
// yes/no). Shared by the intake Review step and the coach's MemberShow so the
// rendering can't drift. Takes the raw prospect_answers shape:
//   { open_ended: [{ key, prompt, answer }], yes_no: [{ key, prompt, answer }] }
// Returns null when there are no answers, so callers can wrap it in a card
// without rendering an empty shell (they should guard too if the wrapper has
// its own chrome).
export function ProspectAnswersList({ answers }) {
  const open = (answers?.open_ended || []).filter(Boolean)
  const yesNo = (answers?.yes_no || []).filter(Boolean)
  if (!open.length && !yesNo.length) return null

  return (
    <div className="space-y-4 text-sm">
      {open.map((a) => (
        <div key={a.key}>
          <p className="text-zinc-500">{a.prompt}</p>
          <p className="mt-0.5 whitespace-pre-line text-zinc-900">
            {a.answer?.trim() ? a.answer : "—"}
          </p>
        </div>
      ))}
      {yesNo.length > 0 && (
        <ul className="space-y-1 pt-2 border-t border-zinc-100">
          {yesNo.map((a) => (
            <li key={a.key} className="flex justify-between gap-4 py-1">
              <span className="text-zinc-600">{a.prompt}</span>
              <span className="font-medium capitalize shrink-0">
                {a.answer || "—"}
              </span>
            </li>
          ))}
        </ul>
      )}
    </div>
  )
}
